import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

/*
    ConfirmDialog Component
    Props: 
        open: Boolean to control dialog visibility
        props: {
            title: Dialog title
            prompt: Dialog prompt message
            id: Optional identifier for returning context
            onClose: Function to call with user response (true/false)
        }
*/

export default function ConfirmDialog({
    open,
    props
}) {
    const handleClose = (response) => {
        if (response && typeof response === 'boolean'){
            props.onClose(response, props.title, props.id);
        } else {
            props.onClose(false);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {props.title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {props.prompt}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => handleClose(false)}>
                    No
                </Button>
                <Button onClick={() => handleClose(true)} autoFocus>
                    Yes
                </Button>
            </DialogActions>
        </Dialog>
    );
}